import { CepAPI } from '@/api/cep.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'

const cepApi = new CepAPI()

const find = (cep: string): AxiosObservable<any> => {
  return cepApi.find(cep)
}

export default { find }
